import React from 'react';
import App from '../App/App';
import {Cards, ImageLayer, ProductBanner} from '../../components';
import FuncCard from '../ProductTMS/FuncCard';
import ValueCard from '../ProductERP/ValueCard';
import {banner, feature, func, structure} from './config';

export default function ProductDC() {
  if (!global.isServer) {
    document.title = '数据中心-数据可视化、智能分析、决策支持';
  }
  return (
    <App className='ProductDC'>
      <ProductBanner data={banner}/>
      <Cards title='核心价值' data={feature} md={2} grey size='middle'>
        <ValueCard />
      </Cards>
      <Cards title='功能模块' data={func} md={4} lm={2} size='middle'>
        <FuncCard />
      </Cards>
      <ImageLayer title='功能架构' src={structure} grey size='middle' noPadding />
    </App>
  );
};



// WEBPACK FOOTER //
// ./src/routes/ProductDC/ProductDC.js